import { render, staticRenderFns } from "./Room.vue?vue&type=template&id=37d922cc&scoped=true&"
import script from "@/views/Rooms/Room.ts?vue&type=script&lang=ts&"
export * from "@/views/Rooms/Room.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Rooms/room.scss?vue&type=style&index=0&id=37d922cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d922cc",
  null
  
)

export default component.exports